import React from "react";
import { Outlet } from "react-router-dom";
import Footer from "../../components/common/Footer";
import Tabs from "../../components/common/Tabs";

const tabs = [
  {
    link: "/communication/letters_templates",
    title: "Letters",
  },
  {
    link: "/communication/resident-forms",
    title: "Resident Forms",
  },
  {
    link: "/communication/messages",
    title: "Messages",
  },
  {
    link: "/communication/email",
    title: "Email",
  },
  {
    link: "/communication/chat",
    title: "Chat",
  },
];

function Communication() {
  return (
      <div className="communication-container">
        <Tabs tabs={tabs} keepFirstLinkActive={true}/>
        <Outlet />
        {/* Footer  */}
        <Footer />
      </div>
  );
}

export default Communication;
